import { useMemo, memo } from 'react';
import HorizontalMenuContent from './Layouts/Horizontal';
import VerticalMenuContent from './Layouts/Vertical';
import { connect } from "react-redux";
import {
    modulesMenuItems
} from './Data/index';
import { 
    isFeatureEnabledForActiveModule,
    isSettingEnabledForActiveModule
} from '../../helpers/module_helper';

const MenuGenerator = (props) => {
    const {
        layout,
        workspace,
        modules,
        user,
        organization,
        menuOpen = false
    } = props;

    const validateMenuItem = (item) => {
        if(item?.authProtected && !user){
            return false;
        }

        if(item?.roles && item?.roles.length > 0){
            if(!user){
                return false;
            }

            let userHasRelatedRole = false;

            for(let i = 0; i < item.roles.length; i++){
                const itemEachRole = item.roles[i];

                if((user?.roles || []).includes(itemEachRole)){
                    userHasRelatedRole = true;
                    break;
                }
            }

            if(!userHasRelatedRole){
                return false;
            }
        }

        if(item?.settingKey && !isSettingEnabledForActiveModule(item.settingKey)){
            return false;
        }

        if(item?.moduleFeatures && item.moduleFeatures.length > 0){
            let moduleHasAnyFeature = false;

            for(let i = 0; i < item.moduleFeatures.length; i++){
                if(isFeatureEnabledForActiveModule(item.moduleFeatures[i])){
                    moduleHasAnyFeature = true;
                    break;
                }
            }

            if(!moduleHasAnyFeature){
                return false;
            }
        }

        if(item?.customValidator && typeof item.customValidator === 'function'){
            return item.customValidator({
                menuItem    :   item,
                modules     :   modules,
                user        :   user,
                organization:   organization
            });
        }

        return true;
    }

    const renderMenuItems = (menuItems) => {
        return menuItems
            .map((item) => {
                if (!validateMenuItem(item)) return null;

                const subMenuItems = item?.items || [];

                if (!subMenuItems.length) {
                    return { ...item };
                }

                const filteredChildren = renderMenuItems(subMenuItems);

                if (!filteredChildren.length) return null;

                return {
                    ...item,
                    items: filteredChildren,
                };
            })
            .filter(Boolean);
    };

    const menuItems = useMemo(() => {
        const moduleMenus = modulesMenuItems[modules?.active];
        
        if(moduleMenus && moduleMenus[workspace.name]){
            return renderMenuItems(moduleMenus[workspace.name]);
        }
    }, [workspace, modules, user]);

    return (
        layout === "horizontal" ? (
            <HorizontalMenuContent 
                menu={ menuItems || [] }
                menuOpen={menuOpen}
            />
        ) : (
            <VerticalMenuContent 
                menu={ menuItems || [] }
            />
        )
    );
}

const mapStatetoProps = (state) => {
    const { Modules: modules, Organization } = state;

    const {
        Login : {
            user,
            token
        },
        Workspace
    } = state;
  
    return {
      modules,
      user,
      token,
      workspace: Workspace,
      organization: Organization
    };
};

export default connect(
    mapStatetoProps, {}
)(memo(MenuGenerator));